export default {
  'GROUP' (state) {
    return state.group
  },
  'GROUPS' (state) {
    return state.groups
  }
}
